import React, { Suspense, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import {
	Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, Center, Divider, Flex, Grid, Image, Spinner, Table, TableContainer,
	Tbody, Td, Text, Th, Tooltip, Tr, useToast,
} from "@chakra-ui/react";
import UploadMenu from "./UploadMenu";
import isFileSelectIcon from "../../assets/Images/isFileSelect.svg";
import fileSelectedIcon from "../../assets/Images/fileSelected.svg";
import Skeleton from "../../reusable-components/LoadingOverlay/Skeleton";
import { useNavigate } from "react-router-dom";
import uploadService from "../../api/uploadService";
import { interceptorsSetup } from "../../api/intreceptor";
import { FaRegHeart } from "react-icons/fa";
import { IoPricetagsOutline } from "react-icons/io5";
import { HiOutlineLockClosed } from "react-icons/hi2";
import { IoLockOpenOutline } from "react-icons/io5";
import { FaHeart } from "react-icons/fa6";
import { CiFolderOn } from "react-icons/ci";
import { FcFolder } from "react-icons/fc";
import { BounceLoader, PuffLoader } from "react-spinners";
import useFetchConfigSetting from "../../hooks/useConfigSetting";
import useCredit from "../../hooks/useCredit";
import configService from "../../api/configService";
import DataTable from "react-data-table-component";
import { CentralizeStore } from "../../contexts/CentralizeStoreProvider";
import LoadingOverlay from "../../reusable-components/LoadingOverlay/LoadingOverlay";
import { IoIosImages } from "react-icons/io";
import { resolveMediaUrl } from "../../utils";

const Upload = () => {
	const [selectedImage, setSelectedImage] = useState([]);
	const [selectedItems, setSelectedItems] = useState(new Set());
	// const [selectedItems, setSelectedItems] = useState([]);
	const [hoveredItem, setHoveredItem] = useState(null);
	const navigate = useNavigate();
	const toast = useToast();
	const [isLoading, setIsLoading] = useState(false);
	const email = localStorage.getItem("email");
	const role = localStorage.getItem("role");
	const [toggleView, setToggleView] = useState(true);
	const [uploadedFile, setUploadedFile] = useState([]);
	// const [selectedImage, setSelectedImage] = useState([]);
	const [isFilterOpen, setIsFilterOpen] = useState(false);
	const { fetchConfigSetting } = useFetchConfigSetting()
	const [isFavLoading, setIsFavLoading] = useState(false);
	const configSetting = JSON.parse(localStorage.getItem("configSetting"))
	const [newConfigSetting, setNewConfigSetting] = useState(null);
	const [search, setSearch] = useState("");
	const [filteredImages, setFilteredImages] = useState([]);
	const { isFilteredExist, IsFilteredExistFalse, IsFilteredExistTrue, setParentPath, parentPath, setParentPathId, parentPathId } = useContext(CentralizeStore)
	const [folders, setFolders] = useState([{ folderName: "Images", id: "7" }, { folderName: "My Docs", id: "8" }]);
	const [loadingId, setLoadingId] = useState(null);
	const comp_id = localStorage.getItem("comp_id")
	const PAGE_SIZE = 12;
	const [hasMore, setHasMore] = useState(false);
	const [isFetchingNextPage, setIsFetchingNextPage] = useState(false);
	const [totalImages, setTotalImages] = useState(null);

	const loadMoreRef = useRef(null);
	const cursorRef = useRef(null);
	const activeFiltersRef = useRef(null);
	const abortControllerRef = useRef(null);
	const isFetchingNextPageRef = useRef(false);

	const sortFolderFirst = (arr) =>
		arr?.slice().sort((a, b) => {
			if (a.type === "folder" && b.type === "file") return -1;
			if (a.type === "file" && b.type === "folder") return 1;
			return 0;
		});

	// Core paginated fetch, shared by the default folder browse and Filter's
	// "Apply" (via onApplyFilters) so both keep working across scroll-triggered
	// next-page fetches. isReset=true starts a fresh cursor (folder switch,
	// filter apply, refresh); isReset=false continues from cursorRef.
	// Memoized on parentPathId (not just refs) so the IntersectionObserver
	// effect below - which only re-subscribes when hasMore/isFetchingNextPage
	// change - can list it as a dependency and pick up folder switches even
	// on the (common) case where hasMore happens to stay true across the switch.
	const fetchImages = useCallback(async (isReset) => {
		if (isReset) {
			// Fresh context - clear any stale guard left by an in-flight
			// next-page fetch that's about to be aborted below.
			isFetchingNextPageRef.current = false;
		} else {
			if (isFetchingNextPageRef.current) return;
			isFetchingNextPageRef.current = true;
		}

		// Abort whatever fetch (reset or next-page) is still in flight so a
		// slow response for the previous folder/filter can never land and
		// get appended after this fetch started (e.g. fast folder switching).
		abortControllerRef.current?.abort();
		const controller = new AbortController();
		abortControllerRef.current = controller;

		if (isReset) {
			setIsLoading(true);
		} else {
			setIsFetchingNextPage(true);
		}
		setIsFavLoading(true);

		try {
			// A filter (Filter.tsx's Apply) is a company-wide search, not scoped
			// to whatever folder happens to be open - parent_path is omitted in
			const payload = {
				email, role, comp_id,
				...(activeFiltersRef.current ? {} : { parent_path: parentPathId }),
				limit: PAGE_SIZE,
				cursor_created_at: isReset ? null : cursorRef.current?.created_at ?? null,
				cursor_id: isReset ? null : cursorRef.current?.id ?? null,
				...(activeFiltersRef.current ? { filters: activeFiltersRef.current } : {}),
			};
			const res = await uploadService.getUploadedImages(payload, { signal: controller.signal });
			if (res.status === 200) {
				const page = res.data?.image_data ?? [];
				const nextCursor = res.data?.next_cursor ?? null;
				cursorRef.current = nextCursor;
				setHasMore(nextCursor !== null);
				// total_images is only sent on the first page (see upload.py) -
				// continuation pages omit it so this just keeps the last known total.
				if (res.data?.total_images != null) {
					setTotalImages(res.data.total_images);
				}
				if (isReset) {
					const sorted = sortFolderFirst(page);
					setUploadedFile(sorted);
					setFilteredImages(sorted);
				} else {
					setUploadedFile((prev) => [...prev, ...page]);
				}
				fetchConfigSetting()
			}
		} catch (err) {
			if (axios.isCancel(err)) return;
			toast({
				title: `${err?.response?.data?.detail}`,
				position: "top",
				status: "error",
				duration: 3000,
				variant: "left-accent",
				isClosable: true,
			});
			console.log("err:", err);
		} finally {
			// Only the still-current (non-superseded) fetch gets to clear
			// loading state - an aborted/superseded one must not clobber
			// whatever fetch replaced it.
			if (abortControllerRef.current === controller) {
				setIsLoading(false);
				setIsFavLoading(false);
				setIsFetchingNextPage(false);
				if (!isReset) isFetchingNextPageRef.current = false;
			}
		}
	}, [email, role, comp_id, parentPathId]);

	const getUploadedImages = useCallback(() => {
		IsFilteredExistFalse()
		activeFiltersRef.current = null;
		cursorRef.current = null;
		return fetchImages(true);
	}, [fetchImages]);

	// Passed down to Filter.tsx so "Apply" reuses this same paginated state
	// machine (cursor/hasMore/abort) instead of a one-shot unpaginated fetch.
	const onApplyFilters = useCallback((filterPayload) => {
		IsFilteredExistTrue()
		activeFiltersRef.current = filterPayload;
		cursorRef.current = null;
		return fetchImages(true);
	}, [fetchImages]);

	useEffect(() => {
		interceptorsSetup(navigate);
	}, [navigate]);

	useEffect(() => {
		handleFetchLatestConfigSetting()
		getUploadedImages();
	}, []);

	useEffect(() => {
		handleClearSelection()
		getUploadedImages();
	}, [parentPathId])

	useEffect(() => {
		const observer = new IntersectionObserver(
			entries => {
				if (entries[0].isIntersecting && hasMore && !isFetchingNextPage) {
					fetchImages(false);
				}
			},
			// Deliberately a small/no margin: a large rootMargin combined with
			// the observer being recreated on every fetch (isFetchingNextPage
			// flips below) re-flags the sentinel as "intersecting" again right
			// after each fetch completes, chaining into the next one with no
			// scroll at all. Network calls should track actual scroll intent.
			{ threshold: 0.2 }
		);

		if (loadMoreRef.current) {
			observer.observe(loadMoreRef.current);
		}

		return () => {
			if (loadMoreRef.current) {
				observer.unobserve(loadMoreRef.current);
			}
		};
	}, [hasMore, isFetchingNextPage, fetchImages]);

	const handleReFetch = () => {
		getUploadedImages();
	};

	const handleToggleView = () => {
		setToggleView(!toggleView);
	};

	// useEffect(() => {
	// 	const selectedData = uploadedFile.filter((item) => selectedItems.has(item.id));
	// 	// console.log("selectedImage data:", selectedImage)
	// 	setSelectedImage(selectedData);
	// }, [selectedItems, uploadedFile]);

	useEffect(() => {
		if (search.length === 0) {
			if (filteredImages.length !== uploadedFile.length) {
				// console.log("Resetting filtered images to uploadedFile");
				setFilteredImages([...uploadedFile]);
			}
		} else {
			const matchingFilteredData = uploadedFile?.filter((el) => {
				if (el.type === "folder") {
					return el.folder_name?.toLowerCase().includes(search.trim().toLowerCase());
				}
				return (
					el.original_image_name.toLowerCase().includes(search.trim().toLowerCase()) ||
					el.created_by.toLowerCase().includes(search.trim().toLowerCase()) ||
					el.image_description.toLowerCase().includes(search.trim().toLowerCase()) ||
					el.created_at.toLowerCase().includes(search.trim().toLowerCase()) ||
					el.domain.toLowerCase().includes(search.trim().toLowerCase())
				);
			});
			setFilteredImages(matchingFilteredData);
		}
	}, [search, uploadedFile]);

	// const selectCounter = useMemo(() => selectedItems.length, [selectedItems]);
	const selectCounter = useMemo(() => selectedItems.size, [selectedItems]);
	const loadedImagesCount = useMemo(() => uploadedFile.filter((el) => el.type === "file").length, [uploadedFile]);

	const handleItemClick = useCallback(
		(id) => {
			const clickedItem = uploadedFile.find((item) => item.id === id);
			// setSelectedImage(clickedItem);
			// Toggle the selection
			setSelectedItems((prevSelectedItems) => {
				const updatedSelection = new Set(prevSelectedItems);
				if (updatedSelection.has(id)) {
					updatedSelection.delete(id);
					setSelectedImage((prevSelected) => prevSelected.filter((item) => item.id !== id));
				} else {
					updatedSelection.add(id);
					setSelectedImage((prevSelected) => [...prevSelected, clickedItem]);
					
				}
				return updatedSelection;
			});
		},
		[uploadedFile]
	);

	const handleItemMouseEnter = useCallback((index) => {
		setHoveredItem(index);
	}, []);

	const handleItemMouseLeave = useCallback(() => {
		setHoveredItem(null);
	}, []);

	const handleClearSelection = useCallback(() => {
		// setSelectedItems([]);
		setSelectedItems(new Set());
		setSelectedImage([])
	}, []);

	const handleSelectAll_old = useCallback(() => {
		if (selectedItems.size === uploadedFile.length) {
			setSelectedItems(new Set()); // Deselect all
			setSelectedImage([]);
		} else {
			const allIds = new Set(uploadedFile.map((item) => item.id));
			setSelectedItems(allIds); // Select all
			setSelectedImage(uploadedFile);
		}
	}, [selectedItems, uploadedFile]);

	const handleSelectAll = useCallback(() => {
		setSelectedItems((prevSelectedItems) => {
			const updatedSelection = new Set(prevSelectedItems);
	
			uploadedFile.forEach((item) => {
				if (!updatedSelection.has(item.id)) {
					updatedSelection.add(item.id);
					setSelectedImage((prevSelected) => [...prevSelected, item]); // Append only new images
				}
			});
	
			return updatedSelection;
		});
	}, [selectedItems,uploadedFile]);

	const toggleFav = async (id, isFav) => {
		setLoadingId(id);
		try {
			const payload = {
				ids: [id],
				is_favourite: isFav ? false : true,
			};
			setIsFavLoading(true);
			const response = await uploadService.addToFavourite(payload);
			if (response.status === 200) {
				getUploadedImages();
			}
		} catch (err) {
			toast({
				title: `${err.response.data.detail}`,
				position: "top",
				status: "error",
				duration: 3000,
				variant: "left-accent",
				isClosable: true,
			});
			console.log("toggle fav err:", err);
		} finally {
			setIsFavLoading(false);
		}
	};

	const handleChangeScope = async (scope: number, imageID) => {
		const ids = [imageID];
		const payload = {
			ids,
			scope: scope
		};

		try {
			const response = await uploadService.changeScope(payload)
			if (response.status === 200) {
				toast({
					title: `${response.data.message}`,
					position: "top",
					status: "success",
					duration: 3000,
					variant: "left-accent",
					isClosable: true,
				})
				handleReFetch()
			}
		} catch (err) {
			toast({
				title: `${err.response.data.detail}`,
				position: "top",
				status: "error",
				duration: 3000,
				variant: "left-accent",
				isClosable: true,
			})
			console.log("scope err:", err)
		} finally {
			handleResetSelectedImages()
			handleClearSelection()
		}
	}

	const handleViewModel = async (id) => {
		const ids = [id];
		let storedEmail = localStorage.getItem("email")
		const params = new URLSearchParams({
			ids: JSON.stringify(ids),
			email: storedEmail
		}).toString();

		navigate(`/layout/model-output?${params}`);
	}

	const handleResetSelectedImages = () => {
		setSelectedImage([]);
	};

	const truncateText = (text, wordLimit) => {
		if (!text) return { truncated: "", isTruncated: false };
		const words = text.split(" ");
		if (words.length > wordLimit) {
			return {
				truncated: words.slice(0, wordLimit).join(" ") + "...",
				isTruncated: true,
			};
		}
		return {
			truncated: text,
			isTruncated: false,
		};
	};

	const truncateImageName = (text, charLimit) => {
		if (!text) return { truncated: "", isTruncated: false };
		if (text.length > charLimit) {
			return {
				truncated: text.slice(0, charLimit) + "...",
				isTruncated: true,
			};
		}
		return {
			truncated: text,
			isTruncated: false,
		};
	}

	const toggleFilter = () => {
		setIsFilterOpen(!isFilterOpen);
	};

	const handleFetchLatestConfigSetting = async () => {
		try {
			const response = await configService.getFeatureConfig(comp_id);
			setNewConfigSetting(response.configuration_data)
		} catch (err) {
			console.log("err while getting config setting: ", err)
		}
	}

	const setFolderPathId = (id) => {
		setParentPathId((prevPath) => `${prevPath}/${id}`)
	}

	const setFolderPath = (folderName, folderId) => {
		setFolderPathId(folderId)
		setParentPath((prevPath) => `${prevPath}/${folderName}`);
	};

	const handleBreadcrumbClick = (index) => {
		const pathArray = parentPath.split("/").slice(0, index + 1);
		setParentPath(pathArray.join("/"));

		const pathArrayId = parentPathId.split("/").slice(0, index + 1);
		setParentPathId(pathArrayId.join("/"));
	};

	const columns = [
		{
			name: "",
			cell: (row, i) => (
				row.type === 'file' || row.type === 'folder' ? (
					<input
						type="checkbox"
						checked={row.selectedItems.includes(row.id)}
						onChange={() => row.handleItemClick(row.id)}
					/>
				) : null
			),
			ignoreRowClick: true,
			allowOverflow: true,
			button: true,
		},
		{
			name: "Image",
			cell: (row, i) => (
				row.type === 'file' ? (
					<img
						src={resolveMediaUrl(row.processed_image_url)}
						alt={`img: ${i}`}
						loading="lazy"
						style={{
							width: "50px",
							height: "50px",
							objectFit: "cover",
							aspectRatio: "1/1",
							padding: "5px"
						}}
					/>
				) : (
					<FcFolder size={15} className="cursorPointer" onDoubleClick={() => setFolderPath(row.folder_name, row.id)} />
				)
			),
		},
		{
			name: "Name",
			cell: (row, i) => {
				const { truncated, isTruncated } =
					row.type === "file"
						? truncateImageName(row?.original_image_name, 18)
						: truncateImageName(row?.folder_name, 18);

				return isTruncated ? (
					<Tooltip label={row.type === "file" ? row.original_image_name : row.folder_name}>
						<span onClick={() => handleItemClick(row.id)} className="cursorPointer">
							{truncated}
						</span>
					</Tooltip>
				) : (
					<span onClick={() => handleItemClick(row.id)} className="cursorPointer">
						{truncated}
					</span>
				);
			},
			sortable: true,
			width: "160px"
		},
		{
			name: "Upload By",
			cell: (row, i) =>
				row.type === 'file' ? (
					<span onClick={() => row.handleItemClick(row.id)} className="cursorPointer">{row.created_by}</span>
				) : null,
			sortable: true,
			width: "173px"
		},
		{
			name: "Upload At",
			cell: (row, i) =>
				row.type === 'file' ? (
					<span className="cursorPointer" onClick={() => row.handleItemClick(row.id)} >
						{new Date(row.created_at)
							.toLocaleDateString("en-GB", {
								day: "2-digit",
								month: "2-digit",
								year: "numeric",
							})
							.replace(/\//g, "-")}
					</span>
				) : null,
			sortable: true,
		},
		{
			name: "Domain",
			cell: (row, i) =>
				row.type === 'file' ? (
					<span onClick={() => row.handleItemClick(row.id)} className="cursorPointer" >
						{(row.image_description !== "" && row.domain == "") ? "Not Available" : row.domain}
					</span>) : null,
			sortable: true,
		},
		{
			name: "Description",
			cell: (row, i) => {
				const { truncated, isTruncated } = truncateText(row.image_description, 6);
				return row.type === 'file' ? (isTruncated ? (
					<Tooltip label={row.image_description}>
						<span onClick={() => handleItemClick(row.id)}>{truncated}</span>
					</Tooltip>
				) : (
					<span onClick={() => handleItemClick(row.id)} className="cursorPointer">{truncated}</span>
				)
				) : null;
			},
			width: "200px"
		},
		{
			name: "Is Favorite",
			cell: (row) =>
				row.type === 'file' ? (
					<div onClick={row.is_favourite ? () => row.toggleFav(row.id, row.is_favourite) : null}>
						{row.is_favourite ? <FaHeart color="red" fontSize={"17px"} /> : <FaRegHeart fontSize={"17px"} />}
					</div>
				) : null,
			ignoreRowClick: true,
			allowOverflow: true,
			button: true,
		},
		{
			name: "Tag Generate Status",
			selector: (row) => (row.type === 'file' ? (row.tag_status === 0 ? "No" : "Yes") : null),
		},
		{
			name: "Scope",
			cell: (row) =>
				row.type === 'file' ? (
					row.scope === 0 ? <HiOutlineLockClosed fontSize={"17px"} /> : <IoLockOpenOutline fontSize={"17px"} />
				) : null,
		},
	];

	const tableStyles = {
		headCells: {
			style: {
				backgroundColor: "#FFFFFF",
				fontWeight: "bold",
				fontSize: "14px",
			},
		},
		cells: {
			style: {
				fontSize: "12px",
			},
		},
	};

	const NoDataComponent = () => (
		<div style={{ textAlign: "center", padding: "20px" }}>
			<strong>No data found</strong>
		</div>
	);
	return (
		<div>
			<Box paddingTop={{ base: "230px", sm: "195", md: "74px", lg: "72px" }} >
				<UploadMenu
					newConfigSetting={newConfigSetting}
					selectCounter={selectCounter}
					onClearSelection={handleClearSelection}
					toggleView={toggleView}
					handleToggleView={handleToggleView}
					selectedImage={selectedImage}
					handleReFetch={handleReFetch}
					handleResetSelectedImages={handleResetSelectedImages}
					handleSelectAll={handleSelectAll}
					toggleFilter={toggleFilter}
					setUploadedFile={setUploadedFile}
					totalUploadedFile={uploadedFile}
					resetFilter={getUploadedImages}
					onApplyFilters={onApplyFilters}
				/>
			</Box>
			{isLoading && <Skeleton />}
			<Box>
				<Breadcrumb separator="/" spacing="2px">
					{parentPath?.split("/").map((folder, index) => (
						<BreadcrumbItem key={index}>
							<BreadcrumbLink color={"#898989"} onClick={() => handleBreadcrumbClick(index)}>
								{folder === 'root' ? "MySpace " : folder}
							</BreadcrumbLink>
						</BreadcrumbItem>
					))}
				</Breadcrumb>
				{(isFilteredExist && uploadedFile?.length > 0) && <Center fontWeight={600} color={"#333333"}>Filtered : {uploadedFile?.length === 0 ? "0" : (uploadedFile?.length < 10 ? `0${uploadedFile?.length}` : uploadedFile?.length)}</Center>}
				{(!isFilteredExist && uploadedFile?.length > 0 && totalImages !== null) && <Center fontWeight={300} fontSize={14} color={"#333333"}>Showing {loadedImagesCount} of {totalImages} images</Center>}
				{
					(uploadedFile?.length === 0 && !isLoading) && <Flex height={"55vh"} alignItems={"center"} justify={"center"}><Text fontWeight={600} fontSize={{ base: "16px", md: "18px", lg: "27px" }}>Empty folder !</Text></Flex>
				}
				{uploadedFile?.length !== 0 &&
					<div>
						{toggleView ? (
							<Suspense fallback={<Skeleton />} >
								{!isLoading &&
									<Grid
										gridTemplateColumns={{
											base: "repeat(1,auto)",
											sm: "repeat(3,200px)",
											md: "repeat(4,1fr)",
											lg: "repeat(6,1fr)",
										}}
										margin={"auto"}
										justifyContent={"center"}
										gap={{ base: "10px", md: "12px", lg: "17px" }}
										mt={6}
										transition={"ease all 0.6s"}
									>
										{uploadedFile?.length > 0 && uploadedFile?.map((el, i) => {
											// const isSelected = selectedItems.includes(i);
											// const isHovered = hoveredItem === i;
											const isSelected = selectedItems.has(el.id);
											const isHovered = hoveredItem === el.id;
											const displayIcon = isSelected ? fileSelectedIcon : isFileSelectIcon;

											return (
												<Tooltip
													label=
													{el.type === "file" ? (
														<>
															<strong>Domain:</strong> {(el.image_description !== "" && el.domain == "") ? "Not Available" : el.domain}
															<br />
															<strong>Description:</strong> {
																Array.isArray(el.image_description) && el.image_description.length > 0
																	? Object.values(el.image_description[0])[0]
																	: typeof el.image_description === "string"
																		? el.image_description
																		: "Not Available"
															}

														</>) : null}
													fontSize="xs"
													key={i}
													placement="auto-start"
												>
													<Flex
														role="group"
														position={"relative"}
														flexDir={"column"}
														key={i}
														alignItems={"center"}
														justifyContent={"center"}
														background={el.type === "file" ? "#FFFFFF" : "none"}
														borderRadius={"7px"}
														width={"100%"}
														height={"100%"}
														_hover={{
															border: isSelected ? "2px solid #7BD6DA" : "1px solid #828282"
														}}
														transition={"ease all 0.6s"}
														padding={"3px"}
														// onMouseEnter={() => handleItemMouseEnter(el.id)}
														// onMouseLeave={handleItemMouseLeave}
														border={isSelected ? "2.4px solid #7BD6DA" : "default"}
														boxShadow={"rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"}
														userSelect={'none'}
													>
														{el.type === "folder" ? (
															<Flex alignItems={"center"} flexDir={"column"} onDoubleClick={() => setFolderPath(el.folder_name, el.id)}>
																<CiFolderOn color="#BDBDBD" fontSize={170} />
																<span className="text-fw">{el.folder_name}</span>
															</Flex>
														) : (
															<Box>
																<Flex
																	alignItems={"center"}
																	// width={"100%"}
																	// height={"100%"}
																	h={"220px"}
																	justifyContent={"center"}
																	onClick={() => handleItemClick(el.id)}
																	cursor={"pointer"}
																>
																	<Image
																		// w={"220px"}
																		// h={"220px"}
																		width={"100%"}
																		height={"100%"}
																		borderRadius={"5px"}
																		src={resolveMediaUrl(el.processed_image_url)}
																		alt={`${el.title + `${i}`}`}
																		objectFit={"cover"}
																		loading={"lazy"}
																	// fallbackSrc='https://via.placeholder.com/150'
																	/>
																</Flex>
																<Flex alignItems="flex-start" justifyContent="flex-end">
																	{el.child?.length > 0 ? <IoIosImages style={{ marginTop: "-18px" }} /> : ''}
																</Flex>
															</Box>
														)}
														{el.type === "file" && <>
															<Flex
																w={"100%"}
																alignItems={"center"}
																justify={"space-around"}
																px={"7px"}
															>
																{isLoading ? (
																	<PuffLoader size={"20px"} />
																) : (
																	<Tooltip
																		label={
																			el.is_favourite
																				? "Remove from favorites"
																				: "Add to favorites"
																		}
																		fontSize="xs"
																	>
																		<Button
																			isDisabled={isFavLoading && loadingId === el.id}
																			colorScheme="black.500"
																			variant="ghost"
																			onClick={() => toggleFav(el.id, el.is_favourite)}
																			cursor={
																				el.is_favourite ? "pointer" : "not-allowed"
																			}
																		>
																			{(isFavLoading && loadingId === el.id) ? <BounceLoader size={20} color="#FC088B" /> : <>
																				{el.is_favourite ? (
																					<FaHeart color="red" fontSize={"17px"} />
																				) : (
																					<FaRegHeart fontSize={"17px"} />
																				)}</>}
																		</Button>
																	</Tooltip>
																)}
																{
																	(configSetting?.Intelli_Tag || newConfigSetting?.Intelli_Search === true) &&
																	<>
																		{el.tag_status === 0 ? (
																			<Button
																				colorScheme="black.500"
																				variant="ghost"
																				cursor="pointer"
																				onClick={() => handleViewModel(el.id)}
																			>
																				{" "}
																				<IoPricetagsOutline
																					cursor={"pointer"}
																					color="#BDBDBD"
																					fontSize={"17px"}
																				/>{" "}
																			</Button>
																		) : (
																			<Button
																				colorScheme="black.500"
																				variant="ghost"
																				cursor="pointer"
																				onClick={() => handleViewModel(el.id)}
																			>
																				<IoPricetagsOutline
																					cursor={"pointer"}
																					color="#4F256F"
																					fontSize={"17px"}
																				/>
																			</Button>
																		)}
																	</>
																}
																{el.scope === 0 ? (
																	<Tooltip label={"Private"} fontSize="xs">
																		<Button
																			colorScheme="black.500"
																			variant="ghost"
																		// cursor="pointer"
																		// onClick={() => handleChangeScope(1, el.id)}
																		>
																			<HiOutlineLockClosed fontSize={"17px"} />{" "}
																		</Button>
																	</Tooltip>
																) : (
																	<Tooltip label={"Public"} fontSize="xs">
																		<Button
																			colorScheme="black.500"
																			variant="ghost"
																		// cursor="pointer"
																		// onClick={() => handleChangeScope(0, el.id)}
																		>
																			<IoLockOpenOutline fontSize={"17px"} />
																		</Button>
																	</Tooltip>
																)}
															</Flex>
															<Text
																m={"0px"}
																pb={"7px"}
																noOfLines={1}
																onClick={() => handleItemClick(el.id)}
																fontSize={"10px"}
																cursor={"pointer"}
																color={"#AAA"}
															>
																Uploaded : {" "}
																{new Date(el.created_at)
																	.toLocaleDateString("en-GB", {
																		day: "2-digit",
																		month: "2-digit",
																		year: "numeric",
																	})
																	.replace(/\//g, "-")}
															</Text>
														</>}
														{isSelected ? (
															<Box
																position={"absolute"}
																top={0}
																right={0}
																padding={"9px 9px 0px 0px"}
																onClick={() => handleItemClick(el.id)}
																cursor={"pointer"}
															>
																<Image src={displayIcon} alt="selectIcon" />
															</Box>
														) : (
															<Box
																position={"absolute"}
																top={0}
																right={0}
																padding={"9px 9px 0px 0px"}
																onClick={() => handleItemClick(el.id)}
																cursor={"pointer"}
																display={"none"}
																_groupHover={{ display: "block" }}
															>
																<Image src={displayIcon} alt="selectIcon" />
															</Box>

														)}
													</Flex>
												</Tooltip>
											);
										})}
									</Grid>

								}
								<div>
									{hasMore && (
										<Center mt={'12%'} mb={'10px'} ref={loadMoreRef} fontSize={"20px"} fontWeight={500} justifyContent={"center"}>
											<Spinner size="lg" color="#FF0087" />
										</Center>
									)
									}
								</div>
							</Suspense>
						) : (
							<Box>
								<Flex padding={"10px"} justifyContent={"flex-end"}>
									<input
										className="view-search-field"
										type="search"
										placeholder="Search"
										value={search}
										onChange={(e) => setSearch(e.target.value)}
									></input>
									{/* <Button size={"sm"} variant={"outline"} colorScheme={"red"} onClick={()=>setSearch("")}>Clear</Button> */}
								</Flex>
								<DataTable
									persistTableHead={true}
									columns={columns}
									// data={filteredImages.map((el, i) => ({ ...el, selectedItems, handleItemClick, toggleFav }))}
									data={filteredImages.map((el) => ({
										...el,
										selectedItems: Array.from(selectedItems), // Convert Set to Array if needed
										handleItemClick: (id) => handleItemClick(id),
										toggleFav: (id, isFav) => toggleFav(id, isFav),
									}))}
									noDataComponent={<NoDataComponent />}
									customStyles={tableStyles}
									pagination
								/>

								{/* <TableContainer bg={"#FFFFFF"} padding={"15px"} borderRadius={"10px"}>
						<Table variant="simple" size="sm">
							<Thead>
								<Tr>
									<Th></Th>
									<Th>Image Name</Th>
									<Th>Upload By</Th>
									<Th>Upload At</Th>
									<Th>Domain</Th>
									<Th>Description</Th>
									<Th>is Favorite</Th>
									<Th>Tag Generate <br/>Status</Th>
									<Th>Scope</Th>
								</Tr>
							</Thead>

							{uploadedFile.length > 0 &&
								uploadedFile?.map((el, i) => {
									const { truncated, isTruncated } = truncateText(el.image_description,5);
									const {truncatedName, isTruncatedName} = truncateImageName(el.original_image_name, 3)
									return (
										<Tbody key={i}>
											<Tr>
												<Td>
													<input
														type="checkbox"
														checked={selectedItems.includes(i)}
														onChange={() => handleItemClick(i)}
													/>
												</Td>
												<Td onClick={() => handleItemClick(i)} cursor={"pointer"} >
													{isTruncatedName ? (
														<Tooltip
															label={el.original_image_name}
															aria-label="Full description"
														>
															<span>{truncatedName}</span>
														</Tooltip>
													) : (
														<span>{truncatedName}</span>
													)}
												</Td>
												<Td
													onClick={() => handleItemClick(i)}
													cursor={"pointer"}
												>
													{el.created_by}
												</Td>
												<Td
													onClick={() => handleItemClick(i)}
													cursor={"pointer"}
												>
													{new Date(el.created_at)
														.toLocaleDateString("en-GB", {
															day: "2-digit",
															month: "2-digit",
															year: "numeric",
														})
														.replace(/\//g, "-")}
												</Td>
												<Td
													onClick={() => handleItemClick(i)}
													cursor={"pointer"}
												>
													{el.domain}
												</Td>
												<Td onClick={() => handleItemClick(i)} cursor="pointer">
													{isTruncated ? (
														<Tooltip
															label={el.image_description}
															aria-label="Full description"
														>
															<span>{truncated}</span>
														</Tooltip>
													) : (
														<span>{truncated}</span>
													)}
												</Td>
												<Td
													cursor={"pointer"}
													onClick={
														el.is_favourite
															? () => toggleFav(el.id, el.is_favourite)
															: null
													}
												>
													{el.is_favourite ? (
														<FaHeart color="red" fontSize={"17px"} />
													) : (
														<FaRegHeart fontSize={"17px"} />
													)}
												</Td>
												<Td>{el.tag_status === 0 ? "No" : "Yes"}</Td>
												<Td>
													{el.scope === 0 ? (
														<HiOutlineLockClosed fontSize={"17px"} />
													) : (
														<IoLockOpenOutline fontSize={"17px"} />
													)}
												</Td>
											</Tr>
										</Tbody>
									);
								})}
						</Table>
					</TableContainer> */}
							</Box>
						)}
					</div>
				}
			</Box>
		</div>
	);
};

export default Upload;
